import {
  Box,
  Card as MuiCard,
  CardProps,
  Stack,
  StackProps,
} from '@mui/material';
import { styled } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';

export const Card = styled((props: CardProps) => <MuiCard {...props} />)(
  ({ theme, $isSelected }) => ({
    width: '274px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '18px',
    textAlign: 'start',
    height: '100%',
    backgroundColor: theme.palette.secondary.lightest,
    ...($isSelected && {
      outline: `3px solid ${theme.palette.primary.dark}`,
    }),
    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
    },
  }),
);

export const MediaContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 249px;
  width: 100%;
`;

export const CardContentContainer = styled((props: StackProps) => (
  <Stack spacing={1} {...props} />
))`
  flex: 1;
  padding: 12px;
`;

export const CardMediaContainer = styled(CardMedia)(
  ({ theme }) => `
    position: relative;
    padding: 16px 13px;
    &:hover .MuiButtonBase-root {
      visibility: visible;
      background-color: ${theme.palette.primary.contrastText};
    }
  `,
);
